import { __decorate } from "tslib";
import { css, LitElement, html } from 'lit';
import { property, query } from 'lit/decorators.js';
import '../../../atom/textarea/element';
import '../../../atom/label/element';
import '../../../atom/paragraph/element';
import '../form-msg/element';
import { DefaultText } from '../../../../lib/validate/defaultText';
import { CheckErrorMsg } from '../../../../lib/validate/checkErrorMsg';
export class FormTextarea extends LitElement {
    constructor() {
        super(...arguments);
        this.validator = new DefaultText(this);
        this.disabled = false;
        this.required = false;
        this.requiredInfoText = '* This field is required';
        this.wrap = 'soft';
        this.keydown = (e) => {
            e.stopImmediatePropagation();
            e.stopPropagation();
            const evt = e;
            if (evt.key === 'Enter') {
                return;
            }
        };
    }
    render() {
        return html `
            <ep-textarea @change="${this.change}" @keyup="${this.keyup}" @keydown="${this.keydown}" .value="${this.value}"></ep-textarea>
            <ep-label @click="${this.click}">${this.label}</ep-label>
            <ep-form-msg></ep-form-msg>
        `;
    }
    firstUpdated() {
        this.defineFor();
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (this.value === undefined) {
            this.value = '';
        }
        if (this.infoText !== undefined && !this.hasAttribute('required')) {
            this._formMsg.infoText = this.infoText;
        }
        if (this.hasAttribute('required')) {
            this.watchRequired();
        }
        if (this.hasAttribute('disabled')) {
            this._textareaItem.setAttribute('disabled', '');
        }
        if (this.hasAttribute('not-valid')) {
            this._textareaItem.setAttribute('not-valid', '');
        }
        if (!this.hasAttribute('not-valid')) {
            this._textareaItem.removeAttribute('not-valid');
        }
        if (this.placeholder !== undefined) {
            this._textareaItem.setAttribute('placeholder', this.placeholder);
            this._textareaItem.classList.add('label-top');
        }
        if (this.cols !== undefined)
            this._textareaItem.setAttribute('cols', this.cols);
        if (this.rows !== undefined)
            this._textareaItem.setAttribute('rows', this.rows);
        if (this.wrap !== undefined)
            this._textareaItem.setAttribute('wrap', this.wrap);
    }
    defineFor() {
        this._labelItem.setAttribute('for', this.name);
        this._textareaItem.setAttribute('id', this.name);
        this._textareaItem.setAttribute('name', this.name);
    }
    watchRequired() {
        var _a;
        this.setAttribute('required', '');
        if (!((_a = this.infoText) === null || _a === void 0 ? void 0 : _a.includes(`${this.requiredInfoText}`)) && this.infoText !== undefined) {
            this.infoText = `${this.requiredInfoText} <br/> ${this.infoText}`;
            this._formMsg.infoText = this.infoText;
        }
        if (this.infoText === undefined) {
            this.infoText = `${this.requiredInfoText}`;
            this._formMsg.infoText = this.infoText;
        }
    }
    click(e) {
        e === null || e === void 0 ? void 0 : e.stopImmediatePropagation();
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        this._textareaItem.focus();
    }
    change(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        const value = e.currentTarget.value;
        this.value = String(value);
        this.dispatchEvent(new CustomEvent('change', {
            composed: true,
            detail: value
        }));
    }
    keyup(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        this.value = e.detail;
        new CheckErrorMsg(this).checkErrorMsg(this.validator.getValidator());
    }
}
FormTextarea.styles = css `
        :host {
            position: relative;
            display: block;
        }

        ep-label {
            display: inline-block;
            position: absolute;
            pointer-events: none;
            left: 5px;
            top: 14px;
            --ep-text-font-size: 16px;
            transition: 0.1s ease all;
            -moz-transition: 0.1s ease all;
            -webkit-transition: 0.1s ease all;
        }

        :host([required]) ep-label:after {
            content: '*';
            font-size: 12px;
            vertical-align: top;
            color: var(--ep-label-text-color);
        }

        ep-textarea.focus ~ ep-label {
            --ep-label-text-color: var(--ep-color-primary);
        }

        ep-textarea[not-valid] ~ ep-label {
            --ep-label-text-color: var(--ep-color-danger);
        }

        ep-textarea.label-top ~ ep-label,
        ep-textarea.focus ~ ep-label {
            top: -9px;
            --ep-text-font-size: 14px;
            background-color: white;
            padding: 0 10px;
        }

        :host([noAfter]) ep-label:after {
            display: none;
        }
    `;
__decorate([
    property()
], FormTextarea.prototype, "placeholder", void 0);
__decorate([
    property()
], FormTextarea.prototype, "name", void 0);
__decorate([
    property()
], FormTextarea.prototype, "label", void 0);
__decorate([
    property()
], FormTextarea.prototype, "value", void 0);
__decorate([
    property()
], FormTextarea.prototype, "infoText", void 0);
__decorate([
    property({ type: Boolean })
], FormTextarea.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], FormTextarea.prototype, "required", void 0);
__decorate([
    property()
], FormTextarea.prototype, "requiredErrorMsg", void 0);
__decorate([
    property()
], FormTextarea.prototype, "requiredInfoText", void 0);
__decorate([
    property({ type: Number })
], FormTextarea.prototype, "minLength", void 0);
__decorate([
    property()
], FormTextarea.prototype, "minLengthErrorMsg", void 0);
__decorate([
    property({ type: Number })
], FormTextarea.prototype, "maxLength", void 0);
__decorate([
    property()
], FormTextarea.prototype, "maxLengthErrorMsg", void 0);
__decorate([
    property()
], FormTextarea.prototype, "rows", void 0);
__decorate([
    property()
], FormTextarea.prototype, "cols", void 0);
__decorate([
    property()
], FormTextarea.prototype, "wrap", void 0);
__decorate([
    query('ep-label')
], FormTextarea.prototype, "_labelItem", void 0);
__decorate([
    query('ep-textarea')
], FormTextarea.prototype, "_textareaItem", void 0);
__decorate([
    query('ep-form-msg')
], FormTextarea.prototype, "_formMsg", void 0);
if (!customElements.get('ep-form-textarea')) {
    customElements.define('ep-form-textarea', FormTextarea);
}
//# sourceMappingURL=element.js.map